import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderZip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H10L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.8043 6.97933 22 7.45 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4ZM16 18H20V8H16V10H18V12H16V14H18V16H16V18ZM4 18H14V16H16V14H14V12H16V10H14V8H11.175L9.175 6H4V18Z",
		fill: "currentColor"
	})
});
export default SvgFolderZip;
